import styles from './index.module.sass';

interface props {
  height: number;
  width: string;
  margin: string;
  style: any;
}

const LoadingRow = ({ height, width, margin, style }: props) => {
  return (
    <div
      className={`${styles.row} ${styles.animate}`}
      style={{ height, width, margin, borderRadius: height / 2, ...style }}
    />
  );
};

export default LoadingRow;
